import { render } from "./BrandStyriaFides.vue?vue&type=template&id=38bea750"
import script from "./BrandStyriaFides.vue?vue&type=script&lang=ts"
export * from "./BrandStyriaFides.vue?vue&type=script&lang=ts"

import "./BrandStyriaFides.vue?vue&type=style&index=0&id=38bea750&lang=scss"
script.render = render

export default script